import AppleBlackIcon from '../../../static/assets/images/common/icn-apple-black.svg';
import PlaystoreBlackIcon from '../../../static/assets/images/common/icn-playstore-black.svg';
import AppleIcon from '../../../static/assets/images/common/DW-Apple.svg';
import GoogleIcon from '../../../static/assets/images/common/DW-Google.svg';

export const menuItems = [
    {
        title: 'The Hub',
        url: '/wallet',
        id: 'wallet',
        className: 'nav_menu-links w-nav-menu',
        dropdown: true,
        footer: true,
        submenu: []
    },
    {
        title: 'The Mint',
        url: '/wealth',
        id: 'wealth',
        className: 'nav_menu-links w-nav-menu',
        dropdown: true,
        hasLine: false,
        footer: true,
        submenu: []
    },
    {
        title: 'The Bank',
        url: '/bank',
        id: 'bank',
        className: 'nav_menu-links w-nav-menu',
        dropdown: true,
        hasLine: false,
        footer: true,
        submenu: []
    },
    {
        title: 'The CHANGE',
        url: '/token',
        id: 'token-page',
        className: 'nav_menu-links w-nav-menu',
        hasLine: false,
        footer: true,
        submenu: [
            /*  {
                  title: 'Overview',
                  url: '/token',
                  id: 'changex_token',
                  link: false
              },
              {
                  title: 'Stake CHANGE',
                  url: 'https://urlgeni.us/changexapp',
                  id: 'changex_token_stake',
                  link: true
             },*/
        ]
    },
    {
        title: 'The Launchpad',
        url: '/launchpad',
        id: 'changex_launchpad-page',
        className: 'nav_menu-links w-nav-menu',
        dropdown: false,
        hasLine: false,
        footer: false,
        submenu: []
    },
    // {
    //     title: 'Learn',
    //     url: '#',
    //     id: 'changex_learn',
    //     className: 'nav_menu-links w-nav-menu',
    //     hasLine: true,
    //     submenu: [
    //         {
    //             title: 'About Changex',
    //             url: '/about',
    //             id: 'changex_about',
    //             link: false
    //         },
    //         {
    //             title: 'Changex Blog',
    //             url: 'https://blog.changex.io/',
    //             id: 'changex_blog',
    //             link: true
    //         },
    //     ]
    // }
];

export const iconItems = [
    {
        src: AppleBlackIcon,
        href: 'https://apps.apple.com/bg/app/changex-wallet/id1613309180',
        class: 'nav_download-btn w-inline-block',
        parentClass: 'nav_download-item',
        id: 'apple'
    },
    {
        src: PlaystoreBlackIcon,
        href: '', //'https://play.google.com/store/apps/details?id=io.changex.app',
        class: 'nav_download-btn w-inline-block',
        parentClass: 'nav_download-item',
        id: 'google'
    }
]

export const mobileIcon = [
    {
        src: AppleIcon,
        href: 'https://apps.apple.com/bg/app/changex-wallet/id1613309180',
        class: 'nav_download-btn w-inline-block',
        parentClass: 'nav_download-item',
        id: 'changex_apple'
    },
    {
        src: GoogleIcon,
        href: '', //'https://play.google.com/store/apps/details?id=io.changex.app',
        class: 'nav_download-btn w-inline-block',
        parentClass: 'nav_download-item',
        id: 'changex_google'
    }
]


export const menuItemsFooter = [
    {
        title: 'The Hub',
        url: '/wallet',
        id: 'changex_wallet',
        className: 'nav_menu-links w-nav-menu',
        dropdown: true,
        footer: true
    },
    {
        title: 'The Bank',
        url: '/bank',
        id: 'changex_bank',
        className: 'nav_menu-links w-nav-menu',
        dropdown: true,
        hasLine: false,
        footer: true
    },
    {
        title: 'The Mint',
        url: '/wealth',
        id: 'changex_wealth',
        className: 'nav_menu-links w-nav-menu',
        dropdown: true,
        hasLine: false,
        footer: true
    },
    {
        title: 'The CHANGE',
        url: '/token',
        id: 'changex_token-page',
        className: 'nav_menu-links w-nav-menu',
        hasLine: true,
        dropdown: true,
        footer: true
    },
    {
        title: 'The Launchpad',
        url: '/launchpad',
        id: 'changex_launchpad',
        className: 'button footer-links w-inline-block',
        hasLine: false,
        link: true
    },

    // {
    //     title: 'Suppported Tokens',
    //     url: '/supported',
    //     id: 'changex_supported-tokens',
    //     className: 'nav_menu-links w-nav-menu',
    //     hasLine: false,
    //     footer: true
    // }
];

export const menuItemsFooter2 = [
    {
        title: 'About Changex',
        url: '/about',
        id: 'changex_about',
        className: 'button footer-links w-inline-block',
        hasLine: false,
        link: true
    },
    {
        title: 'Become A Partner',
        url: '/partner',
        id: 'changex_partner',
        className: 'button footer-links w-inline-block',
        hasLine: false,
        link: true
    },
    {
        title: 'Stake CHANGE',
        url: 'https://hydradex.org/#/swap',
        id: 'changex_token_stake',
        className: 'button footer-links w-inline-block',
        hasLine: false,
        link: false
    },
    {
        title: 'Academy',
        url: 'https://academy.changex.io/',
        id: 'changex-academy-page',
        className: 'nav_menu-links w-nav-menu',
        hasLine: true,
        dropdown: true,
        footer: true
    },
    {
        title: 'Blog',
        url: 'https://blog.changex.io/',
        id: 'changex-blog-page',
        className: 'nav_menu-links w-nav-menu',
        hasLine: true,
        dropdown: true,
        footer: true
    },
    // {
    //     title: 'Press Kit & Assets',
    //     url: 'https://blog.changex.io/changex-presskit-assets/',
    //     id: 'changex_press_assets',
    //     className: 'button footer-links w-inline-block',
    //     hasLine: false,
    //     link: false
    // },
    {
        title: 'Whitepaper',
        url: 'https://whitepaper.changex.io/',
        id: 'changex_whitepaper',
        className: 'button footer-links w-inline-block',
        hasLine: false,
        link: false
    }
];

export const menuItemsFooterSocial = [
    {
        title: 'Telegram',
        url: 'https://t.me/changex_official',
        src: '/assets/images/social/telegram.svg',
        id: 'telegram',
        className: 'button social-link w-inline-block',
        hasLine: false,
        link: true
    },
    {
        title: 'Twitter',
        url: 'https://twitter.com/ChangeXapp',
        src: '/assets/images/social/twitter.svg',
        id: 'twitter',
        className: 'button social-link w-inline-block',
        hasLine: false,
        link: true
    },
    {
        title: 'Discord',
        url: 'https://discord.com/invite/MerANmWQkV',
        src: '/assets/images/social/discord.svg',
        id: 'discord',
        className: 'button social-link w-inline-block',
        hasLine: false,
        link: true
    },
    {
        title: 'Youtube',
        url: 'https://www.youtube.com/@Changex-app/',
        src: '/assets/images/social/youtube.svg',
        id: 'youtube',
        className: 'button social-link w-inline-block',
        hasLine: false,
        link: true
    },
    {
        title: 'Instagram',
        url: 'https://www.instagram.com/changex_app/',
        src: '/assets/images/social/instagram.svg',
        id: 'instagram',
        className: 'button social-link w-inline-block',
        hasLine: false,
        link: true
    },
    {
        title: 'Facebook',
        url: 'https://www.facebook.com/ChangeXapp',
        src: '/assets/images/social/facebook.svg',
        id: 'facebook',
        className: 'button social-link w-inline-block',
        hasLine: false,
        link: true
    },
    {
        title: 'LinkedIn',
        url: 'https://www.linkedin.com/company/changexapp/',
        src: '/assets/images/social/linkedIn.svg',
        id: 'linkedin',
        className: 'button social-link w-inline-block',
        hasLine: false,
        link: true
    }
];
